import { makeStyles } from "@material-ui/styles";

const participantConfirmationStyles = makeStyles((theme) => ({
	participationListContainer: { height: 150, width: "100%", overflowY: "auto" },
	participationList: {
		display: "flex",
		flexDirection: "column",
		gap: "5px",
		alignItems: "center"
	},
	participationListControls: {
		display: "flex",
		gap: theme.spacing(1)
	}
}));

export default participantConfirmationStyles;
